export enum ErrorCode {
  OTHER = 'OTHER'
}

export class ValidateExcelError extends Error {
  private errorCode: ErrorCode;

  constructor(errorCode: ErrorCode, message: string) {
    super();
    this.message = message;
    this.errorCode = errorCode;
  }
}
